import { AddolcireChatLauncher } from "@addolcire/addolcire-ia-chat-component";
import React, { useMemo } from "react";
import { getSession } from "../../processes/sessionProcesses";
import { matchPath, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { currentClassroom } from "../../selectors/classroomSelectors";
import { css } from "glamor";

const containerClass = css({
  position: "fixed",
  zIndex: 1000,
});

const apiEndpoint = process.env.ADDOLCIRE_API_ENDPOINT;
const allowedCourseIds = (process.env.ADDOLCIRE_COURSE_IDS || "")
  .replace(/[\[\]]/g, "")
  .split(",")
  .map((id) => Number(id.trim()))
  .filter(Boolean);

export default function AddolcireChat({ overrideCourseId = false }) {
  const credentials = useMemo(() => getSession()?.headers, []);
  const location = useLocation();
  const classroom = useSelector((state) => currentClassroom(state));

  const subscriptionsMatch = matchPath(location.pathname, {
    path: "/subscriptions/:subscriptionId",
  });

  const lessonsMatch = matchPath(location.pathname, {
    path: "/subscriptions/:subscriptionId/classrooms/:classroomId/lessons/:lessonId",
  });

  const courseId = overrideCourseId ? 0 : classroom?.courseId;
  const subscriptionId = subscriptionsMatch?.params?.subscriptionId;

  if (!overrideCourseId && (!lessonsMatch || subscriptionId != "2"))
    return null;
  if (!overrideCourseId && !allowedCourseIds.includes(courseId)) return null;

  return (
    <div className={containerClass}>
      <AddolcireChatLauncher
        apiEndpoint={apiEndpoint}
        accessToken={credentials["access-token"]}
        client={credentials.client}
        courseId={courseId}
        agentName="Addolcire (beta)"
        agentId="addolcireAgent"
        userId={credentials.uid}
        welcomeMessage="Olá! Bem-vindo(a)! Estou aqui para ajudar com dicas e receitas de confeitaria. O que você quer aprender hoje?"
        failureMessage="Desculpe, ocorreu um erro. Por favor, tente novamente."
      />
    </div>
  );
}
